import { PopupViewModel } from '../empracoTypes';
import { GeneralCookieSettings, GetCookie, SetCookie } from '../generic/CookieFunctions';

export default function Popup(props: PopupViewModel) {
  const { name, active, showInterval, expirationDate, appearOnScroll } = props;
  const cookieSettings = GeneralCookieSettings;
  cookieSettings.liteTime = showInterval !== 0 ? showInterval : 1;
  const hasCookie = GetCookie(cookieSettings.name);
  const popupShown = sessionStorage.getItem(`popupShown-${name}`)
  
  if(!hasCookie && !popupShown) {
      showPopup(true)
  }
  else {
    const hasPopUpCookie = GetCookie(`empori-popup-cookie-${name}`);
    if(!hasPopUpCookie) {
      if(hasCookie){
        SetCookie(`empori-popup-cookie-${name}`, cookieSettings.value, cookieSettings.liteTime);
      }
      
      if (!popupShown) {
        showPopup(true);
      }
    }
  }

  function showPopup(popupVisible: boolean) {
    const popupContainer = document.getElementById('popupContainer');
  
    const handleScroll = () => {
      if (
        active &&
        popupVisible &&
        (!expirationDate || expirationDate === '0001-01-01T00:00:00' || new Date(expirationDate) > new Date())
      ) {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;
  
        if (scrollPosition >= appearOnScroll!) {
          popupContainer!.style.display = 'block';
          sessionStorage.setItem(`popupShown-${name}`, 'true');
          window.removeEventListener('scroll', handleScroll);
        }
      }
    };
  
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }
}
